export enum FlagHashes {
  VERIFIED = '#verified',
  TSV_RECOVERY_CANCELED = '#tsvRecoveryCancelled',
  TSV_REGENERATE_RECOVERY_CODE_SUCCESS = '#tsvRegenerateRecoveryCodeSuccess',
  TSV_REGENERATE_RECOVERY_CODE_UNAUTHORIZED = '#tsvRegenerateRecoveryCodeUnauthorized',
  TSV_ENROLLMENT_SUCCESS = '#tsvEnrollmentSuccess',
  CHANGE_PASSWORD_SUCCESS = '#changePasswordSuccess',
}
